<template>
	<div class="following-empty-state">
		<div class="following-empty-state__title">
			{{ type === TYPES.my_feed ? 'follow' : 'bookmark' }}
			<Icon
				v-if="type === TYPES.saved"
				class="following-empty-state__icon"
				icon-name="bookmark-filled"
				size="xxl"
			/>
		</div>
		<div class="following-empty-state__text">
			{{ type === TYPES.my_feed ? $I18n.trans('arena.fan_account.following.instructions') : $I18n.trans('arena.fan_account.saved.save_favorites') }}
		</div>
		<Button
			v-if="type === TYPES.my_feed"
			:text="$I18n.trans('arena.fan_account.following.follow_favorites')"
			theme="dark"
			@click="$emit('open-follow')"
		/>
	</div>
</template>

<script>
import Button from '@shared/components/Button';
import Icon from '@shared/components/Icon';

const TYPES = {
	following: 'following',
	saved:     'saved',
	my_feed:   'my_feed',
};

export default {
	name:       'FollowingEmptyState',
	components: {
		Button,
		Icon,
	},
	props: {
		type: {
			type:      String,
			default:   TYPES.following,
			validator: value => Object.values(TYPES).includes(value),
		},
	},
	data() {
		return {
			TYPES,
		};
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.following-empty-state {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: $sp7 $sp4;

	@include size(md-up) {
		justify-content: center;
		align-items: center;
		text-align: center;
		border-bottom: 1px solid var(--color-grey-800);
		border-top: 1px solid var(--color-grey-800);
	}
}

.following-empty-state__title {
	position: relative;
	font-size: 80px; // stylelint-disable-line
	color: var(--color-grey-700);
	font-weight: 600; // stylelint-disable-line
	letter-spacing: -0.05em; // stylelint-disable-line
	line-height: 1;
	margin-bottom: -6px;
	margin-left: -6px;

	@include size(md-up) {
		font-size: 100px; // stylelint-disable-line
		margin-left: 0;
		margin-bottom: $sp3;
	}
}

.following-empty-state__text {
	color: var(--color-grey-300);
	margin-bottom: $sp5;
	max-width: 330px;
}

.following-empty-state__icon {
	position: absolute;
	top: 75%;
	right: 2%;
	color: var(--color-white);

	body.-t-light & { // stylelint-disable-line
		color: var(--color-black);
	}
}
</style>
